





































import { Component, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import SalesReportListSearch from '@/components/salesreport/list/Search.vue';
import SalesReportListResult from '@/components/salesreport/list/Result.vue';
import {
  stringToIDate,
  formatApiError,
  translateViewResource,
} from '@/utils/index';
import { translateRouteTitle } from '@/utils/permission';
import { AppModule } from '@/store/modules/app';
import {
  search_agency_sales_reports,
  searchAgencySalesReports,
} from '@/api/salesreport';

@Component({
  name: 'SalesReportList',
  components: {
    MaterialCard,
    SalesReportListSearch,
    SalesReportListResult,
  },
})
export default class extends Vue {
  private reports: search_agency_sales_reports.ReportSummary[] = [];
  private searched = false;

  get salesReportSearchEvent() {
    return SalesReportListSearch.salesReportSearchEvent;
  }

  get canDisplayResult() {
    return this.reports && this.reports.length > 0;
  }

  get canDisplayNoData() {
    return (!this.reports || this.reports.length <= 0) && this.searched;
  }

  get noDataText() {
    return this.$t('No {msg}', {
      msg: (this.$t('Reports') as string).toLowerCase(),
    });
  }

  private async handleSearch(req: search_agency_sales_reports.Request) {
    AppModule.StartProgress();
    try {
      const res = await searchAgencySalesReports(req);
      this.reports = res.reports;
      this.searched = true;
      AppModule.StopProgress();
    } catch (err) {
      this.searched = true;
      AppModule.StopProgress();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
